import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the app state domain
 */

const selectAppDomain = state => state.global || initialState;

const makeSelectAppState = () => createSelector(selectAppDomain, subState => subState);

/**
 * Other specific selectors
 */

const makeSelectUserToken = () => createSelector(selectAppDomain, subState => subState.user.token);

const makeSelectUserTokenLoading = () =>
  createSelector(selectAppDomain, subState => subState.loading);

const makeSelectIsUserToken = () =>
  createSelector(
    selectAppDomain,
    state => state && state.user && state.user.token // bool with token
  );

const makeSelectIsAuthenticated = () =>
  createSelector(
    selectAppDomain,
    state => state && state.user && state.user.isAuthenticated // bool with token
  );

const makeSelectCurrentProject = () =>
  createSelector(selectAppDomain, subState => subState.currentProject);

export {
  makeSelectAppState,
  makeSelectIsUserToken,
  makeSelectIsAuthenticated,
  makeSelectCurrentProject,
  makeSelectUserToken,
  makeSelectUserTokenLoading,
};
